import { Button as BsButton } from "react-bootstrap";
import { CheckCircleFill } from "react-bootstrap-icons";
import { useNavigate, useParams } from "react-router-dom";
import { useAtom } from "jotai";
import { authAtom } from "./Data/Atoms";
import { PayoutOnboardingShell } from "./Controls/PayoutOnboardingShell";

export default function PayoutOnboardingCompletePage() {
  const { facilityId } = useParams<{ facilityId: string }>();
  const nav = useNavigate();
  const [auth] = useAtom( authAtom );

  const financePath = facilityId
    ? `/facility/${facilityId}/finance`
    : undefined;

  return (
    <PayoutOnboardingShell
      title="Onboarding submitted"
      subtitle="Your payout account setup has been received."
      icon={<CheckCircleFill size={24} />}
    >
      <div className="payout-onboarding-neutral-box mb-0">
        Thank you for completing Stripe Connect onboarding. Your payout account
        setup has been submitted. Stripe may require additional verification
        before payouts are enabled.
      </div>

      {auth.isLoggedIn && financePath && (
        <div className="text-center mt-4">
          <BsButton
            variant="outline-secondary"
            className="px-4"
            onClick={() => nav( financePath )}
          >
            Go to Finance
          </BsButton>
        </div>
      )}
    </PayoutOnboardingShell>
  );
}
